import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { BasketActionTypes, BasketActions } from '../';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { basketStorage } from 'storages';
import { ErrorAction } from 'store/root.types';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface RemoveBasketAction extends Action<BasketActionTypes.REMOVE_BASKET> {
}

export interface RemoveBasketActionStart extends Action<BasketActionTypes.REMOVE_BASKET_START> {
}

export interface RemoveBasketActionSuccess extends Action<BasketActionTypes.REMOVE_BASKET_SUCCESS> {
}

export interface RemoveBasketActionError extends ErrorAction<BasketActionTypes.REMOVE_BASKET_ERROR> {
}

export const removeBasket: () => RemoveBasketAction = () => ({
    type: BasketActionTypes.REMOVE_BASKET
});
removeBasket[ACTION_CREATOR_NAME] = 'removeBasket';

export type RemoveBasketFunc = (...args: Parameters<typeof removeBasket>) => void;

export function* removeBasketSaga(): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.REMOVE_BASKET_START
    });

    try {
        basketStorage.removeBasket();

        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_BASKET_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_BASKET_ERROR,
            error: errorToBasketErrorModel(error, 'removeBasketSaga')
        });

        return false;
    }
}